<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  created () {
    this.AdaptiveSize();  //自适应像素
  }
}
</script>

<style>
  body{
    background-color: #EBEFF5;
  }
  input{
    -webkit-appearance: none!important;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }
  .blueColor{
    color: #007AFF !important;
  }
  .Normal07-banner-active{
    background-color: #659a64 !important;
    opacity: 1 !important;
  }
  .Normal26-banner-active{
    background-color: #028c92 !important;
    opacity: .9 !important;
  }
  .Normal27-banner-active{
    background-color: #fff !important;
    opacity: .8 !important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue